import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';

interface CdInfo {
  centroDistribuicao: number;
  tempo: number;
}

export interface ITipoVeiculo {
  exigeAssoalho: boolean;
  codTip: number;
  nome: string;
  duracao: number;
  CDinfo: CdInfo[];
}

export interface ITipoVeiculoResponse {
  tiposVeiculos: ITipoVeiculo[];
  total: number;
}

export const tiposVeiculosService = {
  getTiposCarroceria: (): Promise<AxiosResponse<ITipoVeiculoResponse>> =>
    UDNICK.callService('getTipoVeiculos', {}),
};
